import { useEffect } from "react";

export default function SEO({ title, description, canonical, robots, jsonLd }) {
  useEffect(() => {
    document.title = title
      ? title.includes("|")
        ? title
        : `${title} | RK Group`
      : "RK Group — Jewellery. Real Estate. One Family-Led Group.";
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", description);
    }

    let link = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    } else if (link) {
      link.remove();
    }

    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (robots) {
      if (!robotsMeta) {
        robotsMeta = document.createElement("meta");
        robotsMeta.setAttribute("name", "robots");
        document.head.appendChild(robotsMeta);
      }
      robotsMeta.setAttribute("content", robots);
    } else if (robotsMeta) {
      robotsMeta.remove();
    }

    let ld = document.getElementById("seo-jsonld");
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "seo-jsonld";
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) {
      ld.remove();
    }
  }, [title, description, canonical, robots, jsonLd]);
  return null;
}
